<template>
  <v-dialog v-model="remindOptions" width="450px">
    <v-card elevation="12">
      <v-card-title class="justify-center" style="text-align: center; padding: 0; padding-bottom: 20px">
        <v-container>
          <v-row justify="end">
            <v-col style="padding: 0; margin-left: 20px">
              <span style="font-size: 25px"><b>{{ $t('Notify Via...') }}</b></span>
            </v-col>
            <v-col cols="3" style="padding: 5px 0 0;">
              <v-btn
                icon
                x-large
                style="font-weight: bold; position:relative; bottom: 20px; left: 20px"
                @click="closeOptions"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row justify="center">
            <v-col>
              <v-btn id="sms" :disabled="isWin()" dark x-large color="#43e1b2" style="margin: 5px; position: relative; bottom: 40px; width: 100% " block @click="sendingSMS()">
                {{ $t('SMS') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col>
              <v-btn id="mail" dark x-large color="primary" style="margin: 5px; position: relative; bottom: 60px; width: 100%" block :loading="loadingEmail" @click="sendingEmail()">
                {{ $t('EMAIL') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col>
              <v-btn id="whatsapp" :disabled="isWin()" x-large color="#dee0e6" style="margin: 5px; position:relative; bottom: 80px; width: 100%" block @click="sendWhatsapp()">
                {{ $t('WHATSAPP') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="dataPhones" style="text-align: center">
            <span v-if="!whatsappChose"> {{ $t('If necessary, enter the phone number to send a SMS notification.') }} </span>
            <span v-else> {{ $t('If necessary, enter the phone number to send a Whatsapp notification.') }} </span>
            <v-row justify="center">
              <div v-for="user of data" :key="user.cif">
                <v-row>
                  <v-col cols="9">
                    <v-text-field
                      v-model="user.phone"
                      :label="$t('Phone of ') + user.cif"
                      name="phone number"
                      required
                      type="number"
                      color="#FF6961"
                      prepend-icon="mdi-cellphone-iphone"
                    />
                  </v-col>
                  <v-col cols="2" style="margin-top: 10px; padding: 10px 0 0;">
                    <v-btn class="mx-2" fab small color="primary" @click="sendMessage(user.phone)">
                      <v-icon> mdi-send </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-row>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";

export default {
    name: "RemindOptions",
    data () {
        return {
            remindOptions: false,
            url: "",
            whatsappChose: false,
            dataPhones: false,
            data: [],
            idInvoice: null,
            loadingEmail: false
        };
    },

    methods: {
        show (idFact) {
            this.idFactoring = idFact;
            this.remindOptions = true;
            this.url = Constants.BASE_URL + "#/specific-compensation?id=" + idFact + "&userId=" + this.$user._id;
        },
        closeOptions () {
            this.remindOptions = false;
            this.whatsappChose = false; this.dataPhones = false;
            this.addSizeButton("R");
        },
        addSizeButton (id) {
            id === "sms" ? document.getElementById("sms").style.fontSize = 25 + 'px' : document.getElementById("sms").style.fontSize = 15 + 'px';
            id === "whatsapp" ? document.getElementById("whatsapp").style.fontSize = 25 + 'px' : document.getElementById("whatsapp").style.fontSize = 15 + 'px';
            id === "mail" ? document.getElementById("mail").style.fontSize = 25 + 'px' : document.getElementById("mail").style.fontSize = 15 + 'px';
        },
        getHrefAndroid (phone, message) {
            let messageToSend = message;
            const matches = message.match(/\bhttps?:\/\/\S+/);
            if (matches && matches[0]) {
                messageToSend = messageToSend.replace(matches[0].toString(), '');
                messageToSend = [messageToSend.slice(0, matches.index), encodeURIComponent(matches[0]), messageToSend.slice(matches.index)].join('');
            }
            return "sms:" + phone + "?body=" + encodeURIComponent(messageToSend);
        },
        getHrefiOS (phones, message) {
            let messageToSend = message;
            const matches = message.match(/\bhttps?:\/\/\S+/);
            if (matches && matches[0]) {
                messageToSend = messageToSend.replace(matches[0].toString(), '');
                messageToSend = [messageToSend.slice(0, matches.index), matches[0], messageToSend.slice(matches.index)].join('');
            }
            return "sms://open?addresses=" + phones + "/&body=" + encodeURIComponent(messageToSend);
        },
        isWin () {
            return (!this.isAndroid() && !this.isIOS());
        },
        isAndroid () {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            return /android/i.test(userAgent);
        },
        isIOS () {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        },
        async getPhones () {
            await ApiRepository.getUserPhones(this.idFactoring)
                .then(res => {
                    this.data = res.data.phones;
                })
                .catch((err) => {
                    console.log("ERROR: " + err);
                });
        },
        async sendingSMS () {
            if (!this.dataPhones) await this.getPhones();
            this.whatsappChose = !this.whatsappChose;
            this.dataPhones = true;
        },
        sendMessage (phone) {
            const message = this.$t('I am waiting for your decision. Please go to this link to make an action: ') + this.url;
            if (this.whatsappChose) {
                this.sendWhatsAppMessage(encodeURIComponent(message), phone);
            } else {
                this.sendSMS(message, phone);
            }
        },
        sendSMS (message, phone) {
            console.log(message);
            if (this.isAndroid())
                window.location = this.getHrefAndroid(phone, message);
            else if (this.isIOS())
                window.location.replace(this.getHrefiOS(phone, message));
        },
        sendingEmail () {
            this.dataPhones = false; this.whatsappChose = false;
            //this.$root.$emit('start-loading');
            this.loadingEmail = true;
            ApiRepository.remind(this.idFactoring)
                .then(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('RemindOptions.Reminded successfully'), color: "success"});
                })
                .catch((err) => {
                    console.log("ERROR: " + err);
                }).finally(() => {
                    this.loadingEmail = false;
                    //this.$root.$emit('stop-loading');
                });
        },
        sendWhatsapp () {
            this.getPhones();
            this.whatsappChose = !this.whatsappChose;
            this.dataPhones = true;
        },
        sendWhatsAppMessage (message, phone) {
            window.open("https://api.whatsapp.com/send?phone=+34" + phone + "&abid=+34677882757&text=" + message, '_blank');
        },
    }
};
</script>

<style scoped>
</style>
